export enum AirportResponseType {
  ORIGIN = 'origins',
  DESTINATION = 'destinations',
}
